import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import GetTeam from '/src/utils/GetTeam'
import RichText from '/src/utils/RichText'
import Heading from '../Heading'
import WithLargeImagesFilters from './WithLargeImagesFilters'
import WithLargeImagesSelected from './WithLargeImagesSelected'
import WithLargeImagesAll from './WithLargeImagesAll'

const WithLargeImages = ({ blok }) => {

    // Initiate an empty array
    let tags = []
    // Loop through the selected items, this is used for when we're grabbing all of the items, so all of them
    GetTeam(blok.team).map((item) => {
        // tag_list returns an array of items if more than one tag is associated with the item so we'll loop through them
        item.tag_list.forEach(function (item) {
            // If any of the items in the tag_list array are not already in the parent tags array then add it
            if (!tags.includes(item)) {
                tags.push(item)
            }
        });
        return null
    })
    // Order the tags
    const tagOrder = ["Directors", "Client Managers", "Research", "Field", "Creative", "Technology", "Marketing"]
    tags = tagOrder.filter(v => tagOrder.includes(v));

    const [currentFilter, setCurrentFilter] = useState(tags[0])

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="mx-auto my-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:my-24">
                    <div className="space-y-12 relative h-full">
                        {blok.title && blok.description &&
                            <div className="border-b border-gray-200 pb-4">
                                {blok.title && <Heading size="h2" className="text-darkgrey">{blok.title}</Heading>}
                                {blok.description && 
                                    <div className="text-sm text-darkgrey prose max-w-full">
                                        <RichText>{blok.description}</RichText>
                                    </div>
                                }
                            </div>
                        }
                        {blok.team.length > 0 &&
                            <WithLargeImagesSelected {...blok.team}/>
                        }
                        {blok.team.length === 0 &&
                            <>
                                <WithLargeImagesFilters tags={tags} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter}/>
                                <WithLargeImagesAll team={blok.team} tags={tags} currentFilter={currentFilter}/>
                            </>
                        }
                    </div>
                </div>
            </div>     
        </SbEditable>  
    )
}

export default WithLargeImages